import { render } from "./BSkeletonWrapper.vue?vue&type=template&id=b5a25560"
import script from "./BSkeletonWrapper.vue?vue&type=script&lang=js"
export * from "./BSkeletonWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__